/**
 * TimelineRowRow — `timeline[row]` layout. Horizontal span-bars.
 * Provides the `timeline` slot.
 */
import { LayoutRow } from "./layout-row.ts";

/** The `timeline[row]` layout row: horizontal span bars, providing the `timeline` slot. */
export class TimelineRowRow extends LayoutRow {
  // Distinct from TimelineColumnRow — they are NOT interchangeable.
  // No additional config beyond the base yet.
}
